import { QueryClient } from 'react-query';
import { AuthUnauthorizedError, clearTokens } from '@creditas-lab/auth-sdk';
import { redirectToLogin } from '../utils/redirect';
import { ReactQueryKeys } from '../hooks/queries/keys';
import { UnauthorizedError } from './fetcher';

type OnError = (error: Error, variables?: unknown, context?: unknown) => void;

export type MutationBaseProps<T> = {
  onSuccess?: (data: T, variables?: unknown, context?: unknown) => void;
  onError?: OnError;
};

const handleUnauthorizedError = (error: unknown): void => {
  if (error instanceof AuthUnauthorizedError || error instanceof UnauthorizedError) {
    clearTokens();
    redirectToLogin();
  }
};

const handleMutationError =
  (onError?: OnError) =>
  (error: Error): void => {
    handleUnauthorizedError(error);

    if (onError) {
      onError(error);
    }
  };

let queryClient: QueryClient;

const invalidateQuery = (key: ReactQueryKeys): void => {
  queryClient.invalidateQueries(key);
};

const extendsQueryClient = (receivedQueryClient: QueryClient) => {
  queryClient = receivedQueryClient;

  return receivedQueryClient;
};

export { extendsQueryClient, handleUnauthorizedError, handleMutationError, invalidateQuery };
